export const REGISTRATION_FORM_NAMES = {
  email: 'email',
  first_name: 'first_name',
  last_name: 'last_name',
  password: 'password',
  confirm_password: 'confirm_password',
  privacy_policy_agreed: 'privacy_policy_agreed',
} as const;

export const REGISTRATION_FORM_LABELS = {
  email: 'Email*',
  first_name: 'First name*',
  last_name: 'Last name*',
  password: 'Password*',
  confirm_password: 'Confirm password*',
  privacy_policy_agreed: 'I agree to the Privacy Policy*',
} as const;

export const LOGIN_FORM_NAMES = {
  email: 'email',
  password: 'password',
} as const;

export const LOGIN_FORM_LABELS = {
  email: 'Email*',
  password: 'Password*',
} as const;

export const CREATE_DEBATE_FORM_NAMES = {
  date: 'date',
  time: 'time',
  round: 'round',
  duration: 'duration',
  thesis: 'thesis',
  description: 'description',
} as const;

export const CREATE_DEBATE_FORM_LABELS = {
  date: 'Date*',
  time: 'Time*',
  round: 'Round',
  duration: 'Duration',
  thesis: 'Debate topic*',
  description: 'Debate description*',
} as const;

type TCreateDebateFormValues = {
  round: number[];
  duration: number[];
};

export const CREATE_DEBATE_FORM_VALUES: TCreateDebateFormValues = {
  round: [1, 2, 3, 4, 5],
  duration: [1, 2, 3, 5, 8, 10, 15],
};

export const CHANGE_PASSWORD_FORM_NAMES = {
  old_password: 'old_password',
  new_password: 'new_password',
  confirm_new_password: 'confirm_new_password',
} as const;

export const CHANGE_PASSWORD_FORM_LABELS = {
  old_password: 'Current password*',
  new_password: 'New password*',
  confirm_new_password: 'Confirm password*',
} as const;

export const ENTER_EMAIL_FORM_NAMES = {
  email: 'email',
} as const;

export const ENTER_EMAIL_FORM_LABELS = {
  email: 'Email*',
} as const;

export const PASSWORD_RECOVERY_FORM_NAMES = {
  new_password: 'new_password',
  confirm_new_password: 'confirm_new_password',
} as const;

export const PASSWORD_RECOVERY_FORM_LABELS = {
  new_password: 'New password*',
  confirm_new_password: 'Confirm password*',
} as const;

export const PROFILE_FORM_NAMES = {
  email: 'email',
  first_name: 'first_name',
  last_name: 'last_name',
  groups_info: 'groups_info',
  personal_info: 'personal_info',
} as const;

export const PROFILE_FORM_LABELS = {
  email: 'Email',
  first_name: 'First name',
  last_name: 'Last name',
  groups_info: 'Groups',
  personal_info: 'About',
} as const;
